import { EOFExceptionh831u25jcq9n as EOFException } from './-PlatformJs.mjs';
import {
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  IndexOutOfBoundsException1qfr429iumro0 as IndexOutOfBoundsException,
} from '../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import {
  toString1pkumu07cwy4m as toString,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  subtract2orl8z9upxd9l as subtract,
  add2suhfggl4zvkk as add,
  fromInt2ii0rejb1w62w as fromInt,
  convertToInty04h231mmjoh as convertToInt,
} from '../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import { toShort36kaw0zjdq3ex as toShort } from '../../../kotlin-kotlin-stdlib/kotlin/js/numberConversion.mjs';
import {
  checkBoundsw7d8y6z7j2xc as checkBounds,
  checkOffsetAndCountazlu23xkuwoi as checkOffsetAndCount,
  get_HEX_DIGIT_CHARS28oau3fmf5vf6 as get_HEX_DIGIT_CHARS,
} from './-Util.mjs';
import { ensureNotNull1e947j3ixpazm as ensureNotNull } from '../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { isEmpty39cntv762vey6 as isEmpty } from './Segment.mjs';
import { PeekSource3frbthc9yehpr as PeekSource } from './PeekSource.mjs';
import { buffered3kq86cdmguv3h as buffered } from './Core.mjs';
import { SegmentPool_instance37ddoilc7l0w6 as SegmentPool_instance } from './SegmentPool.mjs';
import {
  write$default11t6ql2kpbkqz as write$default,
  Sink189iybvk4puo6 as Sink,
} from './Sink.mjs';
import { StringBuildermazzzhj6kkai as StringBuilder } from '../../../kotlin-kotlin-stdlib/kotlin/text/StringBuilderJs.mjs';
import {
  UnsafeBufferOperations_instancec5yuwo7wv5k6 as UnsafeBufferOperations_instance,
  get_SegmentReadContextImpl28xxxurlbcmul as get_SegmentReadContextImpl,
} from './unsafe/UnsafeBufferOperations.mjs';
import { _Char___init__impl__6a9atx2yltdocdrxs4d as _Char___init__impl__6a9atx } from '../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { Source1shr0ps16u4p4 as Source } from './Source.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function throwEof($this, byteCount) {
  throw EOFException().n4f("Buffer doesn't contain required number of bytes (size: " + $this.q2().toString() + ', required: ' + byteCount.toString() + ')');
}
var BufferClass;
function Buffer() {
  if (BufferClass === VOID) {
    class $ {
      constructor() {
        this.h4f_1 = null;
        this.i4f_1 = null;
        this.j4f_1 = 0n;
      }
      q2() {
        return this.j4f_1;
      }
      u3v() {
        return this;
      }
      v3v() {
        return this.q2() === 0n;
      }
      w3v(byteCount) {
        // Inline function 'kotlin.require' call
        if (!(byteCount >= 0n)) {
          var message = 'byteCount: ' + byteCount.toString();
          throw IllegalArgumentException().n2(toString(message));
        }
        if (this.q2() < byteCount) {
          throw EOFException().n4f("Buffer doesn't contain required number of bytes (size: " + this.q2().toString() + ', required: ' + byteCount.toString() + ')');
        }
      }
      b3w(byteCount) {
        // Inline function 'kotlin.require' call
        if (!(byteCount >= 0n)) {
          var message = 'byteCount: ' + byteCount.toString() + ' < 0';
          throw IllegalArgumentException().n2(toString(message));
        }
        return this.q2() >= byteCount;
      }
      e3w() {
        var tmp0_elvis_lhs = this.h4f_1;
        var tmp;
        if (tmp0_elvis_lhs == null) {
          throwEof(this, 1n);
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var segment = tmp;
        var segmentSize = segment.q2();
        if (segmentSize === 0) {
          this.v4f();
          return this.e3w();
        }
        var v = segment.w4f();
        this.j4f_1 = subtract(this.j4f_1, 1n);
        if (segmentSize === 1) {
          this.v4f();
        }
        return v;
      }
      x4f() {
        var tmp0_elvis_lhs = this.h4f_1;
        var tmp;
        if (tmp0_elvis_lhs == null) {
          throwEof(this, 2n);
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var segment = tmp;
        var segmentSize = segment.q2();
        if (segmentSize < 2) {
          this.w3v(2n);
          if (segmentSize === 0) {
            this.v4f();
            return this.x4f();
          }
          // Inline function 'kotlinx.io.and' call
          var tmp_0 = (this.e3w() & 255) << 8;
          // Inline function 'kotlinx.io.and' call
          var tmp$ret$1 = this.e3w() & 255;
          return toShort(tmp_0 | tmp$ret$1);
        }
        var v = segment.y4f();
        this.j4f_1 = subtract(this.j4f_1, 2n);
        if (segmentSize === 2) {
          this.v4f();
        }
        return v;
      }
      z4f() {
        return Unit_instance;
      }
      a4g(out, startIndex, endIndex) {
        checkBounds(this.q2(), startIndex, endIndex);
        if (startIndex === endIndex)
          return Unit_instance;
        var currentOffset = startIndex;
        var remainingByteCount = subtract(endIndex, startIndex);
        out.j4f_1 = add(out.j4f_1, remainingByteCount);
        var s = this.h4f_1;
        while (currentOffset >= fromInt(ensureNotNull(s).q4f_1 - s.p4f_1 | 0)) {
          currentOffset = subtract(currentOffset, fromInt(s.q4f_1 - s.p4f_1 | 0));
          s = s.t4f_1;
        }
        while (remainingByteCount > 0n) {
          var copy = ensureNotNull(s).b4g();
          copy.p4f_1 = copy.p4f_1 + convertToInt(currentOffset) | 0;
          var tmp = copy;
          var tmp0 = copy.p4f_1 + convertToInt(remainingByteCount) | 0;
          // Inline function 'kotlin.comparisons.minOf' call
          var b = copy.q4f_1;
          tmp.q4f_1 = Math.min(tmp0, b);
          // Inline function 'kotlinx.io.Buffer.pushSegment' call
          if (out.h4f_1 == null) {
            out.h4f_1 = copy;
            out.i4f_1 = copy;
          } else if (false) {
            out.i4f_1 = ensureNotNull(out.i4f_1).c4g(copy).d4g();
            if (ensureNotNull(out.i4f_1).u4f_1 == null) {
              out.h4f_1 = out.i4f_1;
            }
          } else {
            out.i4f_1 = ensureNotNull(out.i4f_1).c4g(copy);
          }
          remainingByteCount = subtract(remainingByteCount, fromInt(copy.q4f_1 - copy.p4f_1 | 0));
          currentOffset = 0n;
          s = s.t4f_1;
        }
      }
      e4g() {
        var result = this.q2();
        if (result === 0n)
          return 0n;
        var tail = ensureNotNull(this.i4f_1);
        if (tail.q4f_1 < 8192 && tail.s4f_1) {
          result = subtract(result, fromInt(tail.q4f_1 - tail.p4f_1 | 0));
        }
        return result;
      }
      y3t(position) {
        if (position < 0n || position >= this.q2()) {
          throw IndexOutOfBoundsException().i3('position (' + position.toString() + ') is not within the range [0..size(' + this.q2().toString() + '))');
        }
        if (position === 0n) {
          return ensureNotNull(this.h4f_1).f4g(0);
        }
        $l$block_1: {
          // Inline function 'kotlinx.io.seek' call
          if (this.h4f_1 == null) {
            return ensureNotNull(null).f4g(convertToInt(subtract(position, -1n)));
          }
          if (subtract(this.q2(), position) < position) {
            var s = this.i4f_1;
            var offset = this.q2();
            $l$loop: while (!(s == null) && offset > position) {
              offset = subtract(offset, fromInt(s.q4f_1 - s.p4f_1 | 0));
              if (offset <= position)
                break $l$loop;
              s = s.u4f_1;
            }
            var tmp0 = s;
            var offset_0 = offset;
            return ensureNotNull(tmp0).f4g(convertToInt(subtract(position, offset_0)));
          } else {
            var s_0 = this.h4f_1;
            var offset_1 = 0n;
            $l$loop_0: while (!(s_0 == null)) {
              var tmp0_0 = offset_1;
              // Inline function 'kotlin.Long.plus' call
              var other = s_0.q4f_1 - s_0.p4f_1 | 0;
              var nextOffset = add(tmp0_0, fromInt(other));
              if (nextOffset > position)
                break $l$loop_0;
              s_0 = s_0.t4f_1;
              offset_1 = nextOffset;
            }
            var tmp0_1 = s_0;
            var offset_2 = offset_1;
            return ensureNotNull(tmp0_1).f4g(convertToInt(subtract(position, offset_2)));
          }
        }
      }
      a5() {
        return this.l3s(this.q2());
      }
      l3s(byteCount) {
        // Inline function 'kotlinx.io.checkByteCount' call
        // Inline function 'kotlin.require' call
        if (!(byteCount >= 0n)) {
          var message = 'byteCount (' + byteCount.toString() + ') < 0';
          throw IllegalArgumentException().n2(toString(message));
        }
        var remainingByteCount = byteCount;
        while (remainingByteCount > 0n) {
          var tmp0_elvis_lhs = this.h4f_1;
          var tmp;
          if (tmp0_elvis_lhs == null) {
            throw EOFException().n4f('Buffer exhausted before skipping ' + byteCount.toString() + ' bytes.');
          } else {
            tmp = tmp0_elvis_lhs;
          }
          var head = tmp;
          var tmp0 = remainingByteCount;
          // Inline function 'kotlinx.io.minOf' call
          var b = head.q4f_1 - head.p4f_1 | 0;
          // Inline function 'kotlin.comparisons.minOf' call
          var b_0 = fromInt(b);
          var tmp$ret$3 = tmp0 <= b_0 ? tmp0 : b_0;
          var toSkip = convertToInt(tmp$ret$3);
          this.j4f_1 = subtract(this.j4f_1, fromInt(toSkip));
          remainingByteCount = subtract(remainingByteCount, fromInt(toSkip));
          head.p4f_1 = head.p4f_1 + toSkip | 0;
          if (head.p4f_1 === head.q4f_1) {
            this.v4f();
          }
        }
      }
      g4g(sink, startIndex, endIndex) {
        // Inline function 'kotlinx.io.checkBounds' call
        var size = sink.length;
        checkBounds(fromInt(size), fromInt(startIndex), fromInt(endIndex));
        var tmp0_elvis_lhs = this.h4f_1;
        var tmp;
        if (tmp0_elvis_lhs == null) {
          return -1;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var s = tmp;
        var tmp0 = endIndex - startIndex | 0;
        // Inline function 'kotlin.comparisons.minOf' call
        var b = s.q2();
        var toCopy = Math.min(tmp0, b);
        s.h4g(sink, startIndex, startIndex + toCopy | 0);
        this.j4f_1 = subtract(this.j4f_1, fromInt(toCopy));
        if (isEmpty(s)) {
          this.v4f();
        }
        return toCopy;
      }
      i4g(sink, byteCount) {
        // Inline function 'kotlinx.io.checkByteCount' call
        // Inline function 'kotlin.require' call
        if (!(byteCount >= 0n)) {
          var message = 'byteCount (' + byteCount.toString() + ') < 0';
          throw IllegalArgumentException().n2(toString(message));
        }
        if (this.q2() === 0n)
          return -1n;
        var bytesWritten = byteCount > this.q2() ? this.q2() : byteCount;
        sink.j4g(this, bytesWritten);
        return bytesWritten;
      }
      k4g(sink, byteCount) {
        // Inline function 'kotlinx.io.checkByteCount' call
        // Inline function 'kotlin.require' call
        if (!(byteCount >= 0n)) {
          var message = 'byteCount (' + byteCount.toString() + ') < 0';
          throw IllegalArgumentException().n2(toString(message));
        }
        if (this.q2() < byteCount) {
          sink.j4g(this, this.q2());
          throw EOFException().n4f('Buffer exhausted before writing ' + byteCount.toString() + ' bytes. Only ' + this.q2().toString() + ' bytes were written.');
        }
        sink.j4g(this, byteCount);
      }
      l4g(sink) {
        var byteCount = this.q2();
        if (byteCount > 0n) {
          sink.j4g(this, byteCount);
        }
        return byteCount;
      }
      w3x() {
        return buffered(new (PeekSource())(this));
      }
      m4g(minimumCapacity) {
        // Inline function 'kotlin.require' call
        if (!(minimumCapacity >= 1 && minimumCapacity <= 8192)) {
          var message = 'unexpected capacity (' + minimumCapacity + '), should be in range [1, 8192]';
          throw IllegalArgumentException().n2(toString(message));
        }
        if (this.i4f_1 == null) {
          var result = SegmentPool_instance.o3t();
          this.h4f_1 = result;
          this.i4f_1 = result;
          return result;
        }
        var t = ensureNotNull(this.i4f_1);
        if ((t.q4f_1 + minimumCapacity | 0) > 8192 || !t.s4f_1) {
          var newTail = t.c4g(SegmentPool_instance.o3t());
          this.i4f_1 = newTail;
          return newTail;
        }
        return t;
      }
      p4g(source, startIndex, endIndex) {
        // Inline function 'kotlinx.io.checkBounds' call
        var size = source.length;
        checkBounds(fromInt(size), fromInt(startIndex), fromInt(endIndex));
        var currentOffset = startIndex;
        while (currentOffset < endIndex) {
          var tail = this.m4g(1);
          var tmp0 = endIndex - currentOffset | 0;
          // Inline function 'kotlin.comparisons.minOf' call
          var b = tail.q4g();
          var toCopy = Math.min(tmp0, b);
          tail.r4g(source, currentOffset, currentOffset + toCopy | 0);
          currentOffset = currentOffset + toCopy | 0;
        }
        var tmp = this;
        var tmp0_0 = this.j4f_1;
        // Inline function 'kotlin.Long.plus' call
        var other = endIndex - startIndex | 0;
        tmp.j4f_1 = add(tmp0_0, fromInt(other));
      }
      j4g(source, byteCount) {
        // Inline function 'kotlin.require' call
        if (!!(source === this)) {
          var message = 'source == this';
          throw IllegalArgumentException().n2(toString(message));
        }
        checkOffsetAndCount(source.j4f_1, 0n, byteCount);
        var remainingByteCount = byteCount;
        while (remainingByteCount > 0n) {
          if (remainingByteCount < fromInt(ensureNotNull(source.h4f_1).q2())) {
            var tail = this.i4f_1;
            var tmp;
            if (!(tail == null) && tail.s4f_1) {
              var tmp0 = remainingByteCount;
              // Inline function 'kotlin.Long.plus' call
              var other = tail.q4f_1;
              var tmp0_0 = add(tmp0, fromInt(other));
              // Inline function 'kotlin.Long.minus' call
              var other_0 = tail.t4g() ? 0 : tail.p4f_1;
              tmp = subtract(tmp0_0, fromInt(other_0)) <= 8192n;
            } else {
              tmp = false;
            }
            if (tmp) {
              ensureNotNull(source.h4f_1).v4g(tail, convertToInt(remainingByteCount));
              source.j4f_1 = subtract(source.j4f_1, remainingByteCount);
              this.j4f_1 = add(this.j4f_1, remainingByteCount);
              return Unit_instance;
            } else {
              source.h4f_1 = ensureNotNull(source.h4f_1).u4g(convertToInt(remainingByteCount));
            }
          }
          var segmentToMove = ensureNotNull(source.h4f_1);
          var movedByteCount = fromInt(segmentToMove.q2());
          source.h4f_1 = segmentToMove.w4g();
          if (source.h4f_1 == null) {
            source.i4f_1 = null;
          }
          // Inline function 'kotlinx.io.Buffer.pushSegment' call
          if (this.h4f_1 == null) {
            this.h4f_1 = segmentToMove;
            this.i4f_1 = segmentToMove;
          } else if (true) {
            this.i4f_1 = ensureNotNull(this.i4f_1).c4g(segmentToMove).d4g();
            if (ensureNotNull(this.i4f_1).u4f_1 == null) {
              this.h4f_1 = this.i4f_1;
            }
          } else {
            this.i4f_1 = ensureNotNull(this.i4f_1).c4g(segmentToMove);
          }
          source.j4f_1 = subtract(source.j4f_1, movedByteCount);
          this.j4f_1 = add(this.j4f_1, movedByteCount);
          remainingByteCount = subtract(remainingByteCount, movedByteCount);
        }
      }
      x4g(source) {
        var totalBytesRead = 0n;
        $l$loop: while (true) {
          var readCount = source.i4g(this, 8192n);
          if (readCount === -1n)
            break $l$loop;
          totalBytesRead = add(totalBytesRead, readCount);
        }
        return totalBytesRead;
      }
      y4g(byte) {
        this.m4g(1).z4g(byte);
        this.j4f_1 = add(this.j4f_1, 1n);
      }
      a4h(short) {
        this.m4g(2).b4h(short);
        this.j4f_1 = add(this.j4f_1, 2n);
      }
      l6() {
        return Unit_instance;
      }
      toString() {
        if (this.q2() === 0n)
          return 'Buffer(size=0)';
        var maxPrintableBytes = 64;
        // Inline function 'kotlinx.io.minOf' call
        var b = this.q2();
        // Inline function 'kotlin.comparisons.minOf' call
        var a = fromInt(maxPrintableBytes);
        var tmp$ret$0 = a <= b ? a : b;
        var len = convertToInt(tmp$ret$0);
        var builder = StringBuilder().ub(imul(len, 2) + (this.q2() > fromInt(maxPrintableBytes) ? 1 : 0) | 0);
        var bytesWritten = 0;
        // Inline function 'kotlinx.io.unsafe.UnsafeBufferOperations.forEachSegment' call
        var curr = this.h4f_1;
        while (!(curr == null)) {
          var tmp0 = get_SegmentReadContextImpl();
          var segment = curr;
          var idx = 0;
          while (bytesWritten < len && idx < segment.q2()) {
            var _unary__edvuaz = idx;
            idx = _unary__edvuaz + 1 | 0;
            var b_0 = tmp0.c4h(segment, _unary__edvuaz);
            bytesWritten = bytesWritten + 1 | 0;
            var tmp = get_HEX_DIGIT_CHARS();
            // Inline function 'kotlinx.io.shr' call
            var tmp$ret$4 = b_0 >> 4;
            var tmp_0 = builder.o1(tmp[tmp$ret$4 & 15]);
            var tmp_1 = get_HEX_DIGIT_CHARS();
            // Inline function 'kotlinx.io.and' call
            var tmp$ret$5 = b_0 & 15;
            tmp_0.o1(tmp_1[tmp$ret$5]);
          }
          curr = curr.t4f_1;
        }
        if (this.q2() > fromInt(maxPrintableBytes)) {
          builder.o1(_Char___init__impl__6a9atx(8230));
        }
        return 'Buffer(size=' + this.q2().toString() + ' hex=' + builder.toString() + ')';
      }
      v4f() {
        var oldHead = ensureNotNull(this.h4f_1);
        var nextHead = oldHead.t4f_1;
        this.h4f_1 = nextHead;
        if (nextHead == null) {
          this.i4f_1 = null;
        } else {
          nextHead.u4f_1 = null;
        }
        oldHead.t4f_1 = null;
        SegmentPool_instance.d4h(oldHead);
      }
      e4h() {
        var oldTail = ensureNotNull(this.i4f_1);
        var newTail = oldTail.u4f_1;
        this.i4f_1 = newTail;
        if (newTail == null) {
          this.h4f_1 = null;
        } else {
          newTail.t4f_1 = null;
        }
        oldTail.u4f_1 = null;
        SegmentPool_instance.d4h(oldTail);
      }
    }
    protoOf($).s4g = write$default;
    initMetadataForClass($, 'Buffer', Buffer, VOID, [Source(), Sink()]);
    BufferClass = $;
  }
  return BufferClass;
}
//region block: exports
export {
  Buffer as Buffergs925ekssbch,
};
//endregion

//# sourceMappingURL=Buffer.mjs.map
